import axios from 'axios';

window.activeRequests = 0;
const targetSelector = '.js-disable-after-click';
const disabledAdvSelector = 'disabled-adv';

const updateElementState = (disabled) => {
  const elements = document.querySelectorAll(targetSelector);

  elements.forEach((element) => {
    if (disabled) {
      element.setAttribute('disabled', 'true');
      element.classList.add(disabledAdvSelector);
    } else {
      element.removeAttribute('disabled');
      element.classList.remove(disabledAdvSelector);
    }
  });
};

const handleError = () => {
  const activeRequests = window.activeRequests || 0;
  window.activeRequests = Math.max(0, activeRequests - 1);
  if (window.activeRequests === 0) {
    updateElementState(false);
  }
};

const handleSuccess = () => {
  const activeRequests = window.activeRequests || 0;
  window.activeRequests = activeRequests + 1;
  updateElementState(true);
};

export default function (headers = {}) {
  let options = {
    // timeout: 1000,
    headers,
  };

  const tokenDom = document.querySelector('meta[name=csrf-token]');
  if (tokenDom) {
    const csrfToken = tokenDom.content;
    options.headers['X-CSRF-Token'] = csrfToken;
  }

  const axiosClient = axios.create(options);

  axiosClient.interceptors.request.use(
    (config) => {
      handleSuccess();
      return config;
    },
    (error) => {
      handleError();
      return Promise.reject(error);
    },
  );

  // Response interceptor
  axiosClient.interceptors.response.use(
    (response) => {
      handleError();
      return response;
    },
    (error) => {
      handleError();
      return Promise.reject(error);
    },
  );

  return axiosClient;
}
